// api
import { AxiosInstance } from "../axiosInstance";
import APP_URL_ATTENDANCE from "src/constants/attendance";
import { useSelector } from "react-redux";
import { getCurrentUserName, getCurrentUserId } from "src/helpers/currentUser";

const ApiAttendance = () => {
  const TOKEN = useSelector((state) => state.token);
  // SAVE ATTENDANCE
  const saveAttendance = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.SAVE_ATTENDANCE,
        { ...data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };

  // GET ATTENDANCE
  const getAttendance = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ATTENDANCE,
        { ...data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };

  // GET ATTENDANCE COUNTS
  const getAttendanceCounts = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ATTENDANCE_COUNTS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  // GET ATTENDANCE COUNTSREPORT
  const getAttendanceCountsReport = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ATTENDANCE_COUNTS_REPORT,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getTotalAbsences = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_TOTAL_ABSENCES,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getAsistenciaInstitucional = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ASISTENCIA_INSTITUCIONAL,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getResumenAsistencia = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.RESUMEN_ASISTENCIA,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getAsistenciaPorNivelUltimosPeriodos = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ASISTENCIA_POR_NIVEL_ULTIMOS_PERIODOS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getTotalAbsencesByTeacher = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_TOTAL_ABSENCES_BY_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };

  const getTotalTardiness = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_TOTAL_TARDINESS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getTotalTardinessByTeacher = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_TOTAL_TARDINESS_BY_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getAbsencesByGenderAndLevel = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ABSENCES_BY_GENDER_AND_LEVEL,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getAbsencesByGenderAndTeacher = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ABSENCES_BY_GENDER_AND_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getAttendanceSummaryByCourse = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ATTENDANCE_SUMMARY_BY_COURSE,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getAttendanceSummaryByTeacherCourse = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ATTENDANCE_SUMMARY_BY_COURSE_AND_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getTop6StudentsWithMostAbsences = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_TOP6_STUDENTS_WITH_MOST_ABSENCES,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getTop6StudentsWithMostAbsencesTeacher = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_TOP6_STUDENTS_WITH_MOST_ABSENCES_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };
  const getAbsencesByGradeGroup = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ABSENCES_BY_GRADE_GROUP,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };

  const getAbsencesByGradeGroupTeacher = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_ABSENCES_BY_GRADE_GROUP_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };

  // GENERAR PDF PLANILLA ASISTENCIA
  const generarPlanillaAsistencia = async (data) => {
    try {
      const headers = {
        Authorization: `Bearer ${TOKEN}`,
      };

      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.PDF_PLANILLA_ASISTENCIA,
        { ...data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        { responseType: "blob", headers }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const report = document.createElement("a");
      report.href = url;
      report.download = `planilla_asistencia_${data.grado_grupo}_${data.asignatura}.pdf`;

      // report.style.display = "none";

      document.body.appendChild(report);
      report.click();

      document.body.removeChild(report);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error to download" };
    }
  };

  const generarPlanillaAsistenciaMasivaTotal = async (data) => {
    try {
      const headers = {
        Authorization: `Bearer ${TOKEN}`,
      };

      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.PDF_PLANILLA_ASISTENCIA_MASIVA_TOTAL,
        { ...data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        { responseType: "blob", headers }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const report = document.createElement("a");
      report.href = url;
      report.download = `planilla_asistencia_masiva_total.pdf`;

      document.body.appendChild(report);
      report.click();

      document.body.removeChild(report);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error to download" };
    }
  };

  const obtenerOpcionesPlanillaAsistenciaMasiva = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.OPCIONES_PLANILLA_ASISTENCIA_MASIVA,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      return { success: true, response: response.data };
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error to get options" };
    }
  };

  // HISTORIAL DE PLANILLAS DE ASISTENCIA MASIVAS
  const listarHistorialPlanillasAsistencia = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.HISTORIAL_PLANILLA_ASISTENCIA_MASIVA,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  };

  const descargarHistorialPlanillaAsistencia = async (id, nombreArchivo) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.DESCARGAR_HISTORIAL_PLANILLA_ASISTENCIA_MASIVA,
        { id },
        { responseType: "blob", headers: { Authorization: `Bearer ${TOKEN}` } }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const report = document.createElement("a");
      report.href = url;
      report.download = nombreArchivo || "planilla_asistencia_masiva.pdf";
      document.body.appendChild(report);
      report.click();
      document.body.removeChild(report);
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      return { success: false, error: "Error al descargar el archivo" };
    }
  };

  const eliminarHistorialPlanillaAsistencia = async (id) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.ELIMINAR_HISTORIAL_PLANILLA_ASISTENCIA_MASIVA,
        { id },
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  };

  // ESTUDIANTES POR GRADO GRUPO ASISTENCIA
  const getStudentsByDGAttendance = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.STUDENTS_BY_DG_ATTENDANCE,
        { ...data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };

  // LISTAR TODOS LOS ESTUDIANTES CON CLASES SALTADAS
  const listAllStudentSkipped = async () => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.LIST_ALL_STUDENTS_WITH_SKIPPED_CLASSES,
        { nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };

  //ACTUALIZAR ASISTENCIA Y REMOVER CLASES SALTADAS
  const updateAttendanceAndRemoveSkipped = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.UPDATE_ATTENDANCE_AND_REMOVE_SKIPPED,
        { data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };

  const updateAttendanceAndRemoveSkippedBatch = async (attendanceData) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.UPDATE_ATTENDANCE_AND_REMOVE_SKIPPED_BATCH,
        { attendance_data: attendanceData, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  };

  // RESUMEN GENERAL DE INASISTENCIAS POR DÍA (todos los cursos)
  const getDailyAbsenceSummary = async (idanio_lectivo, course_id, fecha_desde, fecha_hasta) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_DAILY_ABSENCE_SUMMARY,
        { idanio_lectivo, course_id, fecha_desde, fecha_hasta },
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  };

  // REPORTE DE ASISTENCIA (preview JSON)
  const getReporteAsistencia = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_REPORTE_ASISTENCIA,
        { ...data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  };

  // REPORTE DE ASISTENCIA (exportar Excel)
  const exportReporteAsistenciaExcel = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.EXPORT_REPORTE_ASISTENCIA_EXCEL,
        { ...data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = "reporte_asistencia.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return { success: true };
    } catch (error) {
      return { success: false, error: "Error al descargar el reporte" };
    }
  };

  // HISTORIAL MENSUAL ASISTENCIA DOCENTES
  const getTeacherAttendanceMonthly = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_TEACHER_ATTENDANCE_MONTHLY,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  };

  const getLatePermissionByTeacher = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_LATE_PERMISSION_BY_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  };

  const getTeachersLatePermissions = async () => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.GET_TEACHERS_LATE_PERMISSIONS,
        { nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  };

  const saveLatePermission = async (data) => {
    try {
      const response = await AxiosInstance.post(
        APP_URL_ATTENDANCE.SAVE_LATE_PERMISSION,
        { ...data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  };

  return {
    saveAttendance,
    getAttendance,
    getAttendanceCounts,
    getAttendanceCountsReport,
    getTotalAbsences,
    getAsistenciaInstitucional,
    getResumenAsistencia,
    getAsistenciaPorNivelUltimosPeriodos,
    getTotalAbsencesByTeacher,
    getTotalTardiness,
    getTotalTardinessByTeacher,
    getAbsencesByGenderAndLevel,
    getAbsencesByGenderAndTeacher,
    getAttendanceSummaryByCourse,
    getAttendanceSummaryByTeacherCourse,
    getTop6StudentsWithMostAbsences,
    getTop6StudentsWithMostAbsencesTeacher,
    getAbsencesByGradeGroup,
    getAbsencesByGradeGroupTeacher,
    generarPlanillaAsistencia,
    generarPlanillaAsistenciaMasivaTotal,
    obtenerOpcionesPlanillaAsistenciaMasiva,
    listarHistorialPlanillasAsistencia,
    descargarHistorialPlanillaAsistencia,
    eliminarHistorialPlanillaAsistencia,
    getStudentsByDGAttendance,
    listAllStudentSkipped,
    updateAttendanceAndRemoveSkipped,
    updateAttendanceAndRemoveSkippedBatch,
    getTeacherAttendanceMonthly,
    getDailyAbsenceSummary,
    getReporteAsistencia,
    exportReporteAsistenciaExcel,
    getLatePermissionByTeacher,
    getTeachersLatePermissions,
    saveLatePermission,
  };
};

export default ApiAttendance;
